import { createAsyncThunk } from "@reduxjs/toolkit";
import { KubernetesAiSavingsOpportunity } from "@/services/cloudchipr.api";
import { initiateResourceDetailsDrawerThunk } from "@/store/resource-details/thunks/initiateResourceDetailsDrawerThunk";
import { getInitiateResourceDetailsDrawerThunkArgsFromAiKubernetesOpportunity } from "@/store/ai-kubernetes-recommendations/utils/helpers/getInitiateResourceDetailsDrawerThunkArgsFromAiKubernetesOpportunity";
import { getKubernetesResourceByResourceTypeThunk } from "@/store/ai-kubernetes-recommendations/thunks/getKubernetesResourceByResourceTypeThunk";
import { KubernetesResourceType } from "@/store/ai-kubernetes-recommendations/utils/types/types";
import { setK8SLiveUsageResourceDetailsDrawerResourceDataThunk } from "@/store/kubernetes-live-usage-mgmt/thunks/resources/setK8SLiveUsageResourceDetailsDrawerResourceDataThunk";

export const setAiKubernetesRecommendationsResourceDetailsDrawerResourceDataThunk =
  createAsyncThunk(
    "aiKubernetesRecommendations/setAiKubernetesRecommendationsResourceDetailsDrawerResourceData",
    async (
      {
        opportunity,
        enableBillingCostAndForecastedEOMForOpportunities,
      }: {
        opportunity: KubernetesAiSavingsOpportunity;
        enableBillingCostAndForecastedEOMForOpportunities?: boolean;
      },
      { dispatch },
    ) => {
      const initialArgs =
        getInitiateResourceDetailsDrawerThunkArgsFromAiKubernetesOpportunity(
          opportunity,
          enableBillingCostAndForecastedEOMForOpportunities,
        );

      if (!initialArgs) {
        return;
      }

      dispatch(initiateResourceDetailsDrawerThunk(initialArgs));

      if (!opportunity.cluster.cluster_id || !opportunity.resource_name) {
        return;
      }

      try {
        const resource = await dispatch(
          getKubernetesResourceByResourceTypeThunk({
            resourceType: opportunity.service as KubernetesResourceType,
            clusterId: opportunity.cluster.id,
            name: opportunity.resource_name,
            namespace: opportunity.resource_namespace ?? undefined,
          }),
        ).unwrap();

        if (!resource) {
          return;
        }

        dispatch(
          setK8SLiveUsageResourceDetailsDrawerResourceDataThunk({
            resource,
            enableAiKubernetesRecommendations: true,
          }),
        );
      } catch (e) {
        console.error(e);
      }
    },
  );
